import { createAPI } from '@common'

export default {
  // 保存直播-新建
  postNisLive: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf', 'POST', config),
  // 保存直播-修改
  postNisLiveUpdate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0vqebuf', 'POST', config),
  // 获取直播信息
  getNisLive: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf', 'get', config),
  // 获取具体直播详情（直播稿件用
  getNisByLiveId: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuCzMjwfJe', 'get', config),
  getNisLiveControllerUrl: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0dpouspmmfs0vsm', 'GET', config),
  deleteNisLive: (config) => createAPI('customEncryptApiName-1/0w20ojt0mjwf', 'DELETE', config),
  // 直播通道信息
  getNisLiveChannel: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0diboofm', 'get', config),
  // 设置直播授权人
  postNisLiveChannelUserSet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0bvuipsj{f', 'post', config),
  // 修改直播
  putNisLive: (config) => createAPI('customEncryptApiName-1/0w20ojt0mjwf', 'PUT', config),
  // 操作：查询分组
  getGroups: (config) => createAPI('customEncryptApiName-1/0w20hspvqt', 'GET', config),
  // 直播是否被引用、发布
  getNisLiveUse: (config) => createAPI('customEncryptApiName-1/0w20ojt0mjwf0vtf', 'GET', config),
  // 获取审核规则
  getNisLiveAuditRule: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0bvejuSvmf', 'GET', config),
  // 切换审核规则
  postNisLiveAuditRule: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0bvejuSvmf', 'POST', config),
  // 单路直播模板
  getNisLiveTemplate: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0ufnqmbuft', 'GET', config),
  // 直播拆条
  getNisLiveUnpackUrl: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0voqbdl0vsm', 'GET', config),
  // 直播收录
  getNisLiveIncludeUrl: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0jodmvef0vsm', 'GET', config),
  // 开启通道
  postNisLiveChannelOpen: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0diboofm0pqfo', 'POST', config),
  // 关闭通道
  postNisLiveChannelClose: (config) =>
    createAPI('customEncryptApiName-1/0w20ojt0mjwf0diboofm0dmptf', 'POST', config),
  // 根据id获取音视频分组name
  getMamGroupNames: (config) => createAPI('customEncryptApiName-1/0w20nbn0hspvq0obnft', 'GET', config),
  // 导播台创建
  addCaster: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0beeDbtufs', 'POST', config),
  // 导播台删除
  deleteCaster: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0efmfufDbtufs', 'POST', config),
  // 导播台详情
  getCasterDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EftdsjcfDbtufsEfubjmJogp',
      'POST',
      config
    ),
  // 获取导播台license参数
  getLicense: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0hfuMjdfotf', 'POST', config),
  // 获取导播台id
  getCasterID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0hfuDbtufsJE', 'POST', config),
  // 腾讯第三方接口
  // 修改导播台信息
  ModifyCaster: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufs', 'POST', config),
  // 添加输入源
  addCasterInputInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0BeeDbtufsJoqvuJogp', 'POST', config),
  // 修改输入源
  modifyCasterInputInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufsJoqvuJogp',
      'POST',
      config
    ),
  // 删除输入源
  deleteCasterInputInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EfmfufDbtufsJoqvuJogp',
      'POST',
      config
    ),
  // 生成导播台推流链接，作为输入源之一
  createCasterInputPushUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0DsfbufDbtufsJoqvuQvtiVsm',
      'POST',
      config
    ),
  // 新增导播台输出信息设置
  addCasterOutputInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0BeeDbtufsPvuqvuJogp', 'POST', config),
  // 修改导播台的输出信息
  modifyCasterOutputInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufsPvuqvuJogp',
      'POST',
      config
    ),
  // 启动预监任务
  createCasterPvw: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0DsfbufDbtufsQwx', 'POST', config),
  // 开启主监输出
  createCasterPvwPgm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0DsfbufDbtufsQwxQhn', 'POST', config),
  // 停止主监输出
  stopCasterPgm: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0TupqDbtufsQhn', 'POST', config),
  // 停止预监输出
  stopCasterPvw: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0TupqDbtufsQwx', 'POST', config),
  // 获取导播台视频流的播放url
  describeCasterPlayUrl: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EftdsjcfDbtufsQmbzVsm',
      'POST',
      config
    ),
  // 新增图片水印信息
  addCasterMarkPicInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0BeeDbtufsNbslQjdJogp',
      'POST',
      config
    ),
  // 修改图片水印信息
  modifyCasterMarkPicInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufsNbslQjdJogp',
      'POST',
      config
    ),
  // 删除图片水印信息
  deleteCasterMarkPicInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EfmfufDbtufsNbslQjdJogp',
      'POST',
      config
    ),
  // 新增文字水印信息
  addCasterMarkWordInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0BeeDbtufsNbslXpseJogp',
      'POST',
      config
    ),
  // 修改文字水印信息
  modifyCasterMarkWordInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufsNbslXpseJogp',
      'POST',
      config
    ),
  // 删除文字水印信息
  deleteCasterMarkWordInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EfmfufDbtufsNbslXpseJogp',
      'POST',
      config
    ),
  // 转场列表
  describeCasterTransitionTypes: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EftdsjcfDbtufsUsbotjujpoUzqft',
      'POST',
      config
    ),
  // 直播水印相关
  // 新增图片水印
  creatWaterMark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0dsfbuXbufsNbsl', 'POST', config),
  // 修改图片水印
  updateWaterMark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0vqebufXbufsNbsl', 'POST', config),
  // 删除图片水印
  deleteWaterMark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0efmfufXbufsNbsl', 'POST', config),
  // 图片水印详情
  waterMarkDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0xbufsNbslEfubjm', 'POST', config),
  // 新增文字水印
  createText: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0dsfbufUfyu', 'POST', config),
  // 修改文字水印
  updateText: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0vqebufUfyu', 'POST', config),
  // 删除文字水印
  deleteText: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0efmfufUfyu', 'POST', config),
  // 文字水印详情
  textDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfXbufsNbsl0ufyuEfubjm', 'POST', config),
  // 判断什么时候显示"趣看"类型的直播
  getQuKanConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuRvLboDpogjh', 'GET', config),
  // 新增导播台布局
  addCasterLayoutInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0BeeDbtufsMbzpvuJogp', 'POST', config),
  // 修改导播台布局
  modifyCasterLayoutInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0NpejgzDbtufsMbzpvuJogp',
      'POST',
      config
    ),
  // 删除导播台布局
  deleteCasterLayoutInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwfHvjef0EfmfufDbtufsMbzpvuJogp',
      'POST',
      config
    ),
  // 获取是否播放流画面
  getLiveStreamStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuTusfbnTubuvt', 'GET', config),
  // 修改是否播放流画面
  updateLiveStream: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0vqebufTusfbn', 'POST', config),
  // 获取直播回看列表
  getLiveRecordList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0hfuSfdpse', 'POST', config),
  // 修改直播回看列表
  setLiveRecord: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0tfuSfdpse', 'POST', config),
  // 保存商品
  saveCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dpnnpejuz0tbwf', 'POST', config),
  // 删除商品
  deleteCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dpnnpejuz0efmfuf', 'POST', config),
  // 直播-批量获取商品信息
  getLiveCommodityList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dpnnpejuz0mjtu', 'POST', config),
  // 直播-保存商品
  saveLiveCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0dpnnpejuz0tbwf', 'POST', config),
  // 直播-删除商品
  deleteLiveCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0dpnnpejuz0efmfuf', 'POST', config),
  // 直播-上下架商品
  showLiveCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0dpnnpejuz0tipx', 'POST', config),
  // 直播-开关商品讲解
  expoundLiveCommodity: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0dpnnpejuz0fyqpvoe', 'POST', config),
  // 直播手动拉流
  getStartPull: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0tubsuQvmm', 'GET', config),
  // 已经选择的直播抽奖列表
  getLiveLotteryList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0mjtu', 'GET', config),
  // 添加选用的抽奖
  addLiveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0bee', 'POST', config),
  // 删除选用的抽奖
  delLiveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0efm', 'GET', config),
  // 添加选用的抽奖-发布
  pubLiveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0qvc', 'GET', config),
  // 添加选用的抽奖-撤回
  revokeLiveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0sfwplf', 'GET', config),
  // 添加选用的抽奖-结束
  stopLiveLottery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sbggmf0tupq', 'GET', config),
  // 拉流转推列表
  getLiveRetweetList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfuxffu0mjtu', 'GET', config),
  // 新建、修改拉流转推
  addLiveRetweet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfuxffu0bee', 'POST', config),
  // 删除拉流转推
  delLiveRetweet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfuxffu0efm', 'GET', config),
  // 开启拉流转推
  openLiveRetweet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfuxffu0pqfo', 'POST', config),
  // 关闭拉流转推
  closeLiveRetweet: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0mjwf0sfuxffu0dmptf', 'POST', config),
  // 创建直播通道
  addPreset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0qsftfu0tbwf', 'POST', config),
  // 删除直播通道
  deletePreset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt.mjwf0qsftfu0efmfuf', 'GET', config)
}
